import produceClone from 'src/helper/produceClone';
import ProductRepository from 'src/repository/ProductRepository';
import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';

class ResponseMaker {
    data = [];
    data_to_send = {
        orderItemList: {},
        orderNumber: ''
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        if (this.data.results !== undefined && this.data.results.items && this.data.results.items.length > 0) {
            let value = [];
            let currencyVal = ''
            if (this.data.results.currency) {
                currencyVal = this.data.results.currency && this.data.results.currency
            }
            this.data.results.items.map((v, i) => {
                let here_v = {}

                here_v.ERPPartNumber = v['matnr']

                if (v['lineItemNumber']) {
                    here_v.lineItemNumber = v['lineItemNumber']
                }
                if (v['manufacturer']) {
                    here_v.manufacturer = v['manufacturer']
                }
                if (v['manufacturerPartNumber']) {
                    here_v.manufacturerPartNumber = v['manufacturerPartNumber']
                }
                if (v['customerPartNumber']) {
                    here_v.customerPartNumber = v['customerPartNumber']
                }
                if (v['qtyOrdered']) {
                    here_v.quantity = v['qtyOrdered']
                }
                if (v['qtyDelivered']) {
                    here_v.deliveredQuantity = v['qtyDelivered']
                } else {
                    here_v.deliveredQuantity = 0
                }
                if (v['qtyRemaining']) {
                    here_v.remainingQuantity = v['qtyRemaining']
                } else {
                    here_v.remainingQuantity = 0
                }
                if (v['pricePerUnit']) {
                    here_v.unitPrice = v['pricePerUnit']
                } else {
                    here_v.unitPrice = 0
                }
                if (v['priceLineTotal']) {
                    here_v.totalPrice = v['priceLineTotal']
                } else {
                    here_v.totalPrice = 0
                }
                if (v['manufacturer']) {
                    here_v.manufacturer = v['manufacturer']
                }
                if (v['manufacturerName']) {
                    here_v.manufacturerName = v['manufacturerName']
                }
                if (v['invoiceNum'] && v['invoiceNum'].trim() !== '' && v['invoiceNum'].trim() !== 'N/A') {
                    here_v.invoiceNumber = v['invoiceNum']
                }
                if (v['carrier']) {
                    here_v.carrier = v['carrier']
                }
                if (v['itemOrderDate']) {
                    here_v.orderDate = v['itemOrderDate']
                    here_v.finalOrderDate = Helper.dateFormatFromString(v['itemOrderDate'])
                }
                if (v['deliveryDate']) {
                    here_v.deliveryDate = v['deliveryDate']
                    here_v.finalDeliveryDate = Helper.dateFormatFromString(v['deliveryDate'])
                }
                if (v['status']) {
                    here_v.status = v['status'].toLowerCase() === 'pending' ? 'Order Placed' : v['status']
                }
                if (v['statusName']) {
                    here_v.statusName = v['statusName']
                }
                if (v['orderType']) {
                    here_v.orderType = v['orderType']
                }
                if (v['releaseNumber']) {
                    here_v.releaseNumber = v['releaseNumber']
                }
                here_v.currency = currencyVal
                here_v.uniqueNumber = Helper.UUID()
                here_v.cartFrom = 'order'

                value[i] = here_v;
            })

            if (this.data.orderNumber) {
                this.data_to_send.orderNumber = this.data.orderNumber
            }
            let orderLineItems = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(value, false, false);
            this.data_to_send.orderItemList = orderLineItems
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;